<template>
  <div class="banner">
    <div class="logo"></div>
    <div class="age-tips"></div>
    <div class="slogan">
      <div class="slogan__desc"></div>
      <div class="play-btn" @click="openVideoBox"></div>
    </div>
    <template v-if="stage == 0">
      <div class="reservation">
        <span class="text">已有</span>
        <span class="count">{{ reserveCount }}</span>
        <span class="text">人预约《从前有条街》</span>
      </div>
      <div class="reserve">
        <div class="reserve__btn reserve--official" @click="openReserveDialog" :class="{ finished: isReserved }"></div>
        <div class="reserve__btn reserve--taptap" @click="openLink"></div>
      </div>
    </template>
    <template v-else-if="stage == 1">
      <div class="download-box">
        <div class="left">
          <div class="tips">扫码下载游戏</div>
          <div class="code"></div>
        </div>
        <div class="right">
          <div class="download-btn ios" @click="download('ios')"></div>
          <div class="download-btn android" @click="download('android')"></div>
        </div>
        <!-- <div class="download__btn taptap" @click="openLink"></div> -->
      </div>
      <div class="download-btn__group">
        <div class="download-btn__item thunder" @click="openDownloadLink('thunder')"></div>
        <div class="download-btn__item mumu" @click="openDownloadLink('mumu')"></div>
        <div class="download-btn__item taptap" @click="openDownloadLink('taptap')"></div>
        <div class="download-btn__item hykb" @click="openDownloadLink('hykb')"></div>
      </div>
    </template>
    <video-box :visible.sync="videoBoxVisible" :src="video" />
  </div>
</template>

<script>
import VideoBox from './components/VideoBox.vue'

import bannerMixins from '@/mixins/home/bannerMixins.js'

export default {
  name: 'PcHomeBanner',
  mixins: [bannerMixins],
  components: {
    VideoBox,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/pc/btns.scss';

.banner {
  position: relative;
  width: 100%;
  height: 960px;
  background: url('~@/assets/img/pc/banner_bg.jpg') no-repeat;
  background-position: center;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 302px;
    background: url('~@/assets/img/pc/banner_cover.png') no-repeat;
    background-position: center;
  }
}

.logo {
  position: absolute;
  top: 0;
  left: 0;
  width: 240px;
  height: 550px;
  background: url('~@/assets/img/pc/logo.png') no-repeat;
}

.age-tips {
  position: absolute;
  top: 553px;
  left: 53px;
  width: 92px;
  height: 118px;
  background: url('~@/assets/img/pc/age.png') no-repeat;
}

.slogan {
  position: absolute;
  top: 75px;
  left: 50%;
  transform: translateX(-180px);
  width: 584px;
  height: 316px;
  background: url('~@/assets/img/pc/slogan1.png') no-repeat;

  .play-btn {
    position: absolute;
    top: 25px;
    right: -60px;
    width: 78px;
    height: 78px;
    cursor: pointer;

    &::before {
      content: '';
      display: block;
      width: 78px;
      height: 78px;
      background: url('~@/assets/img/common/play_btn.png') no-repeat;
      animation: rotate 10s linear infinite;
    }

    &::after {
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: block;
      width: 19px;
      height: 22px;
      background: url('~@/assets/img/common/play_btn.png') no-repeat;
      background-position: -78px 0;
    }
  }
}

.reservation {
  position: absolute;
  top: 387px;
  left: 50%;
  transform: translateX(-230px);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 674px;
  height: 56px;
  background: url('~@/assets/img/common/people_bg.png') no-repeat;

  .text {
    font-size: 26px;
    letter-spacing: 3px;
    color: transparent;
    background-image: linear-gradient(180deg, #ffffff, #ffedab);
    background-clip: text;
  }

  .count {
    margin: 0 15px;
    color: #ffd851;
    font-size: 40px;
    -webkit-text-stroke: 1px #000;
  }
}

.reserve {
  position: absolute;
  top: 470px;
  left: 50%;
  transform: translateX(-62px);
  width: 311px;

  &__btn {
    width: 311px;
    height: 76px;
    cursor: pointer;

    &:not(:last-of-type) {
      margin-bottom: 36px;
    }
  }

  &--official {
    background: $btnsBackgroud;
    background-position: $reservationBtnPos;

    &:hover {
      background-position: $reservationBtnActivePos;
    }

    &.finished,&.finished:hover {
      background: url('~@/assets/img/pc/reserve_btn3.png') no-repeat;
      background-size: 100%;
      cursor: default;
    }
  }

  &--taptap {
    background: $btnsBackgroud;
    background-position: $reservationTaptapBtnPos;

    &:hover {
      background-position: $reservationTaptapBtnActivePos;
    }
  }
}

.download-box {
  position: absolute;
  top: 387px;
  left: 50%;
  transform: translateX(-130px);
  display: flex;
  align-items: center;
  margin-top: 12px;
  width: 478px;
  height: 160px;
  background: url('~@/assets/img/pc/download_bg.png') no-repeat;

  .left {
    margin: 0 10px 0 48px;
    display: flex;
    align-items: center;

    .tips {
      margin-right: 8px;
      font-family: Noto Serif SC;
      font-size: 16px;
      color: #fff;
      letter-spacing: 2px;
      writing-mode: vertical-lr;
    }

    .code {
      width: 126px;
      height: 126px;
      background: url('~@/assets/img/common/wechat.jpg') no-repeat;
      background-size: 100% 100%;
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 208px;
    height: 126px;

    .download-btn {
      width: 208px;
      height: 56px;
      background: url('~@/assets/img/pc/download_btn.png') no-repeat;
      cursor: pointer;

      &.ios {
        background-position: 0 0;
      }
      &.android {
        background-position: 0 -56px;
      }
    }
  }
}

.download__btn.taptap {
  position: absolute;
  left: 50%;
  bottom: -96px;
  transform: translateX(-50%);
  width: 311px;
  height: 76px;
  cursor: pointer;
  background: $btnsBackgroud;
  background-position: $reservationTaptapBtnPos;

  &:hover {
    background-position: $reservationTaptapBtnActivePos;
  }
}

.download-btn {
  &__group {
    z-index: 1;
    position: absolute;
    left: 50%;
    top: 650px;
    transform: translateX(-690px);
    display: flex;
  }

  &__item {
    margin-right: 12px;
    width: 308px;
    height: 76px;
    background-size: 100%;
    background-repeat: no-repeat;
    cursor: pointer;

    &.thunder {
      background-image: url('~@/assets/img/pc/btn1_inactive.png');
      &:hover {
        background-image: url('~@/assets/img/pc/btn1_active.png');
      }
    }
    &.mumu {
      background-image: url('~@/assets/img/pc/btn2_inactive.png');
      &:hover {
        background-image: url('~@/assets/img/pc/btn2_active.png');
      }
    }
    &.taptap {
      background-image: url('~@/assets/img/pc/btn3_inactive.png');
      &:hover {
        background-image: url('~@/assets/img/pc/btn3_active.png');
      }
    }
    &.hykb {
      background-image: url('~@/assets/img/pc/btn4_inactive.png');
      &:hover {
        background-image: url('~@/assets/img/pc/btn4_active.png');
      }
    }
  }
}
</style>